import { AssetsPie } from "../components/data/graphData";
import { linearModel } from "../components/data/methodsData";
import {
  IAMDefinedBenefitTable,
  YTDPerformanceTable,
} from "../components/data/tableData";

export const contentTypeEnum = {
  nothing: 1,
  newsList: 2,
  newsDetail: 3,
  graph: 4,
  table: 5,
  text: 6,
  simulationTable: 7,
  historicalRiskFactorDetail: 8,
  customRiskCalculation: 9,
  riskHistoricalList: 10,
  
};

export const TABLE_NAMES = {
  "YTD Performance by index": YTDPerformanceTable,
  "YTD Performance portfolio": IAMDefinedBenefitTable,
};

export const METHOD_NAMES = {
  "Longitudinal Monte Carlo": linearModel,
};

export const GRAPH_NAMES = {
  "Iam Defined Benefit": AssetsPie,
};

export const SIMULATION_MAP = {
  runEconomicCycleSimulation: "simulation1",
  runBenchmarkSimulation: "simulation2",
  runNoARSimulation: "simulation3",
  runBenchmarkNoAR: "simulation4",
};
